import { VxModelsLogo } from '@campoint/odi-ui-icons';
import {
  Box,
  Button,
  Container,
  Flex,
  HStack,
  Heading,
  Icon,
} from '@chakra-ui/react';
import React from 'react';

import { ProfileFieldTypePictureFragment } from '../../../generated/graphql';
import { noop } from '../../../utils';
import { ProfilePicture } from './components/ProfilePicture/ProfilePicture';
import { TitlePicture } from './components/TitlePicture/TitlePicture';

export type ProfileHeaderProps = {
  modelPictureTitleLandscape:
    | ProfileFieldTypePictureFragment
    | undefined
    | null;
  buttonText: string;
  //TODO: This is needed to hide the "visit profile" button if the profile has not yet been activated. If the button is no longer displayed in the feed context, the property can be deleted.
  isButtonHidden?: boolean;
  isEditable?: boolean;
  modelPictureFSK16Avatar: ProfileFieldTypePictureFragment | undefined | null;
  onButtonClick: () => void;
  username: string;
};

/**
 * This component is needed for the model profile and the feed.
 * @constructor
 */
const ProfileHeader: React.FC<ProfileHeaderProps> = ({
  modelPictureTitleLandscape,
  modelPictureFSK16Avatar,
  username,
  onButtonClick = noop,
  buttonText,
  isButtonHidden = false,
  isEditable = true,
}) => {
  return (
    <Container maxW={'full'} p={0}>
      <TitlePicture
        field={modelPictureTitleLandscape}
        isEditable={isEditable}
      />
      <Flex
        w={'full'}
        flexWrap={'wrap'}
        flexDirection={'row'}
        alignItems={'flex-end'}
        rowGap={'7'}
      >
        <HStack
          maxW={'full'}
          mt={{ base: '-50px', lg: '-75px' }}
          ml={{ base: '4', lg: '12' }}
          alignItems={'flex-end'}
          gap={'7'}
          flexGrow={1}
        >
          <Box flexShrink={0}>
            <ProfilePicture
              field={modelPictureFSK16Avatar}
              isEditable={isEditable}
            />
          </Box>
          <Flex overflowX={'hidden'} flexGrow={1}>
            <Heading
              fontSize={{ base: 'xl', lg: '4xl' }}
              noOfLines={1}
              wordBreak={'break-word'}
            >
              {username}
            </Heading>
          </Flex>
        </HStack>
        <Container flexShrink={1} w={'min-content'} px={4} centerContent>
          {!isButtonHidden && (
            <Button
              variant="outline"
              children={buttonText}
              onClick={onButtonClick}
              leftIcon={<Icon as={VxModelsLogo} />}
            />
          )}
        </Container>
      </Flex>
    </Container>
  );
};

export default ProfileHeader;
